import { TrafficNode } from '../trafficNodes/trafficNode';
/**
 * class {PointFavorite}
 * should be used to represent a Point Favorite with optional informations
 */
export class PointFavorite {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param cssClass
     * @param label
     * @param node
     * @param imageUrl
     */
    constructor(cssClass, label, node, imageUrl) {
        this._cssClass = cssClass;
        this._label = label;
        this._node = node;
        this._imageUrl = imageUrl;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {PointFavorite}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.cssClass = values.cssClass || '';
        sanitizedValues.label = values.label || '';
        sanitizedValues.node = values.node !== undefined ? TrafficNode.factory(values.node) : TrafficNode.factory({});
        sanitizedValues.imageUrl = values.imageUrl || '';
        return new PointFavorite(sanitizedValues.cssClass, sanitizedValues.label, sanitizedValues.node, sanitizedValues.imageUrl);
    }
    /**
     * gets the cssClass information for the favorite
     * @returns {string}
     */
    get cssClass() {
        return this._cssClass;
    }
    /**
     * sets the cssClass information for the favorite
     * @param value
     */
    set cssClass(value) {
        this._cssClass = value;
    }
    /**
     * gets the label for the favorite
     * @returns {string}
     */
    get label() {
        return this._label;
    }
    /**
     * sets the label for the favorite
     * @param value
     */
    set label(value) {
        this._label = value;
    }
    /**
     * gets the TrafficNode fo the favorite
     * @returns {TrafficNode}
     */
    get node() {
        return this._node;
    }
    /**
     * sets the TrafficNode fo the favorite
     * @param value
     */
    set node(value) {
        this._node = value;
    }
    /**
    * gets the ImageUrl for the favorite
    * @returns {string}
    */
    get imageUrl() {
        return this._imageUrl;
    }
    /**
     * sets the TrafficNode fo the favorite
     * @param value
     */
    set imageUrl(value) {
        this._imageUrl = value;
    }
}
//# sourceMappingURL=pointFavorite.js.map